// import "./DataTable.css";
// import Pagination from "../Pagination/Pagination";
// import React from "react";

// const Rec = ({ children, flex, onClick, reader, transform }) => {
// 	const data = reader ? reader(children) : children;
// 	const transformedData = Array.isArray(data)
// 		? data.map((item) =>
// 			typeof item === "string" && transform ? transform(item) : item
// 		)
// 		: data;

// 	return (
// 		<div className="TableRecord">
// 			{transformedData.map((rec, index) => (
// 				<div
// 					onClick={() => (onClick ? onClick(children) : null)}
// 					style={{ flex: flex[index] + "%" }}
// 					key={index}
// 				>
// 					{rec}
// 				</div>
// 			))}
// 		</div>
// 	);
// };

// const DataTable = ({
// 	children,
// 	flex,
// 	onClick,
// 	reader,
// 	transform,
// 	pageable,
// 	totalPages,
// 	handlePagination,
// }) => {
// 	const { heading, data } = children;
// 	const dr = Array.isArray(data) ? data : data.content;
// 	const pg = Array.isArray(data) ? pageable : data.pageable;
// 	const tp = Array.isArray(data) ? totalPages : data.totalPages;

// 	return (
// 		<div className="DataTable">
// 			<div className="TableHead">
// 				{heading &&
// 					heading.map((head, index) => (
// 						<div style={{ flexBasis: flex[index] + "%" }} key={index}>
// 							{typeof head === "string" && transform ? transform(head) : head}
// 						</div>
// 					))}
// 			</div>
// 			{dr?.length ? (
// 				<div className="TableRecords">
// 					{dr.map((rec, index) => (
// 						<Rec
// 							reader={reader}
// 							onClick={onClick}
// 							flex={flex}
// 							transform={transform}
// 							key={index}
// 						>
// 							{rec}
// 						</Rec>
// 					))}
// 				</div>
// 			) : (
// 				<div className="TableNoRecord">
// 					<center>No record available</center>
// 				</div>
// 			)}
// 			{pg && (
// 				<Pagination
// 					onClick={handlePagination}
// 					pageable={pg}
// 					totalPages={tp}
// 				></Pagination>
// 			)}
// 		</div>
// 	);
// };

// export default DataTable;


import "./DataTable.css";
import Pagination from "../Pagination/Pagination";
import React from "react";

// const Rec = ({ children, flex, onClick, reader, transform }) => {
//   const data = reader ? reader(children) : children;

//   const transformedData = Array.isArray(data)
//     ? data.map((item) =>
//         typeof item === "string" && transform ? transform(item) : item
//       )
//     : data;

//   return (
//     <tr
//       className="TableRecord"
//       onClick={() => (onClick ? onClick(children) : null)}
//       style={{ cursor: onClick ? "pointer" : "default" }}
//     >
//       {transformedData.map((rec, index) => (
//         <td key={index} style={{ width: flex[index] + "%" }}>
//           {rec}
//         </td>
//       ))}
//     </tr>
//   );
// };

const Rec = ({ children, flex, onClick, reader, transform }) => {
  const data = reader ? reader(children) : children;

  const transformedData = Array.isArray(data)
    ? data.map((item) =>
        typeof item === "string" && transform ? transform(item) : item
      )
    : data;

  return (
    <tr
      className="TableRecord"
      onClick={() => (onClick ? onClick(children) : null)}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      {transformedData.map((rec, index) => (
        <td key={index} style={{ width: flex[index] + "%" }}>
          <div className="TableCellFlexWrapper">
            {rec}
          </div>
        </td>
      ))}
    </tr>
  );
};

const DataTable = ({
  children,
  flex,
  onClick,
  reader,
  transform,
  pageable,
  totalPages,
  handlePagination,
}) => {
  const { heading, data } = children;

  const dr = Array.isArray(data) ? data : data.content;
  const pg = Array.isArray(data) ? pageable : data.pageable;
  const tp = Array.isArray(data) ? totalPages : data.totalPages;

  return (
    <div className="DataTable">
      <table>
        {/* Table Head */}
        <thead>
          <tr>
            {heading &&
              heading.map((head, index) => (
                <th key={index}>
                  {typeof head === "string" && transform
                    ? transform(head)
                    : head}
                </th>
              ))}
          </tr>
        </thead>

        {/* Table Body */}
        <tbody>
          {dr?.length ? (
            dr.map((rec, index) => (
              <Rec
                reader={reader}
                onClick={onClick}
                flex={flex}
                transform={transform}
                key={index}
              >
                {rec}
              </Rec>
            ))
          ) : (
            <tr className="TableNoRecord">
              <td colSpan={heading?.length || 1}>
                <center>No record available</center>
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination */}
      {pg && (
        <Pagination
          onClick={handlePagination}
          pageable={pg}
          totalPages={tp}
        ></Pagination>
      )}
    </div>
  );
};

export default DataTable;
